<template>
  <Modal v-model="autoCancelOrderConfigModal" :title="$t('key1001835')" width="700" :transfer="false"
    :mask-closable="false" @on-visible-change="autoCancelOrderConfigChange">
    <div class="flex align-items-center mb15">
      <span>{{ $t('key1002150') }}</span>
      <RadioGroup v-model="autoCancelOrderValue" class="position-relative flex_1" style="top: -1px;">
        <Radio :label="1" class="mr30">{{ $t('key1000462') }}</Radio>
        <Radio :label="0">{{ $t('key1000463') }}</Radio>
      </RadioGroup>
    </div>
    <div class="flex align-items-center mb15" v-if="autoCancelOrderValue === 1">
      <span class="red-dot">{{ $t('key1002151') }}</span>
      <InputNumber :max="99999" :min="1" v-model="autoCancelOrderTime" :formatter="value => `${parseInt(value)}`"
        style="width: 100px; text-align: center;" class="ml8 mr8">
      </InputNumber>
      <span>min</span>
    </div>
    <template #footer>
      <Button @click="autoCancelOrderConfigModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="autoCancelOrderConfigBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {saveErpCommonSettingParam} from "@/utils/common";

export default {
  name: 'autoCancelOrderConfigModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      autoCancelOrderConfigModal: false,
      autoCancelOrderValue: 1,
      autoCancelOrderTime: null,
      configParamKey: null
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  methods: {
    // 初始化数据
    initAutoCancelOrderData(paramKey, obj) {
      if (obj) {
        this.autoCancelOrderValue = Number(obj.autoCancelOrderValue);
        this.autoCancelOrderTime = Number(obj.autoCancelOrderTime);
      }
      this.configParamKey = paramKey;
      this.autoCancelOrderConfigModal = true;
    },
    // 确定
    autoCancelOrderConfigBtn() {
      if (this.autoCancelOrderTime === null) {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002149'));
        return false;
      }
      let obj = {
        autoCancelOrderTime: this.autoCancelOrderTime,
        autoCancelOrderValue: this.autoCancelOrderValue,
      };
      let queryList = [
        {
          businessId: this.userInfo.merchantId,
          paramKey: this.configParamKey,
          paramValue: JSON.stringify(obj),
        }
      ];
      saveErpCommonSettingParam(queryList).then(() => {
        this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000708'));
        this.autoCancelOrderConfigModal = false;
        this.$emit('updateConfigData', true);
      });
    },
    // 监听弹窗
    autoCancelOrderConfigChange(value) {
      if (!value) {
        this.autoCancelOrderValue = 1;
        this.autoCancelOrderTime = null;
        this.configParamKey = null;
      }
    }
  },
  watch: {},
  components: {}
};
</script>

<style lang="less">

</style>
